import React, { createContext, useContext } from 'react'
import axiosFactory, { METHOD_POST } from '../helpers/AxiosFactory'
import { GET_LAWYER_BY_ID, GET_LAWYER_BY_FILTERS, GET_LAWYER_DIRECTORY } from '../helpers/UrlConstants'
const LawyerContext = createContext()
export function useLawyerContext() {
    return useContext(LawyerContext)
}
export default function LawyerProvider({ children }) {
    async function getLawyerById(data) {
        return await axiosFactory({
            url: GET_LAWYER_BY_ID,
            method: METHOD_POST,
            data: data,
        })
    }
    async function getLawyersByFilter(data) {
        return await axiosFactory({
            url: GET_LAWYER_BY_FILTERS,
            method: METHOD_POST,
            data: data,
        })
    }
    // Public directory: paginated, stable order, public fields only.
    async function getLawyersDirectory(data) {
        return await axiosFactory({
            url: GET_LAWYER_DIRECTORY,
            method: METHOD_POST,
            data: data,
        })
    }
    const value = {
        getLawyerById,
        getLawyersByFilter,
        getLawyersDirectory

    }
    return (
        <LawyerContext.Provider value={value}>
            {children}
        </LawyerContext.Provider>
    )
}
